function hasNumber(str) {
    return /\d/.test(str);
}

function hasLowerCase(str) {
    return (/[a-z]/.test(str));
}
function hasUpperCase(str) {
    return (/[A-Z]/.test(str));
}
export function validateEmail(email) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (regex.test(email)) {
        return true;
    } else {
        return false;
    }
}
//TODO check symbols
export function validatePassword(password) {
    if (password.length > 6 && hasNumber(password) && hasUpperCase(password) && hasLowerCase(password))
        return true;
    else
        return false;
}
export function validateChildPassword(password) {
    if (password.length > 4 && hasLowerCase(password))
        return true;
    else
        return false;
}
export function checkPasswordMatch(psw1, psw2) {
    if (psw1 == psw2) {
        return true;
    } else {
        return false;
    }
}
export function validateNames(name) {
    if (name.length > 1 && !hasNumber(name)) {
        return true;
    } else {
        return false;
    }
}